export default __webpack_public_path__ + "static/media/ic_laos.b80fcff0.svg";